import { NgModule } from '@angular/core';
import {
  AddNewProductOneClickFeature,
  AdjustmentOrderFeature,
  LeadTimesApiBlkAdt,
  BoomPumpFeature,
  CalendarViewFeature,
  CancelOrderFeature,
  CatalogPCMFeature,
  ChatBotAivoFeature,
  ChatBotWizelineFeature,
  CreatePodRequestFeature,
  CreateReceivingPersonModalFeature,
  ExtendedLogFeature,
  HideIndicativePricesFeature,
  IsOnlineOrderFeature,
  IsSalesReadonlyFeature,
  LocationAndSpecificationFeature,
  ModifyOrderFeature,
  NeorisLogoFeature,
  NewActionLogsFeature,
  OnHoldOrderFeature,
  OrderActionMenuFeature,
  PumpingServiceFeature,
  ReceiveMyProductsFromV3Feature,
  RepeatOrderFeature,
  RmsWayFeature,
  RmxAdditionalInfoFeature,
  ShowLoadDefaultCatalogValuesFeature,
  ShowLoadDefaultReceivingPerson,
  ShowProductCatalogFavoriteTabFeature,
  ShowProductCatalogMyListTabFeature,
  ShowProductCatalogOrdersTabFeature,
  ShowProductCatalogProductCatTabFeature,
  ShowProductCatalogSuggestedTabFeature,
  ShowReqAndOrderFeature,
  EnableDownloadExcelFeature,
  ShowTermsCheckboxOnUploadDocument,
  ShowUploadDocumentDropdownsFeature,
  TimeNegotiationFeature,
  WalkMeFeature,
  PurchaseOrderMaskValidationFeature,
  HideMultiplePurchaseOrderFeature,
  CoBrowseFeature,
  SimmaOnlineFeature,
  AutomaticValidationFeature,
  DcoImprovementFeature,
  OrderSubscriptionFeature,
  EnableCounterofferMatchBulkCEMFeature,
  CalendarViewV2Feature,
  EnableOrderAvailabilityExpirationTimeFeature,
  EnableOrderModificationExpirationTimeFeature,
  EnablePODDropdownFeature,
  ProductDescriptionHomologationFeature,
  EnableSpecialScenariosMooFeature,
  EnableBusinessDaysCutOffFeature,
  EnableActionLogV7Feature,
  EnableContractsExpirationDateFeature,
  EnableSpacingValidationByQtyLoadSize,
  EnablePODMooDropdownFeature,
  EnablePODDeleteMooFeature,
  OrderMissingFieldsAlert,
  PalletsDefaultUnitBagCemFeature,
  PaymentTermsFeature,
  LoadSizeFeature,
  DeliveryTimePickerFeature,
  DeliveryTimeWindowSelectFeature,
  EnableAdmixturesProductTypeFeature,
  ShowOneDeliveryMethodForAdmixturesFeature,
  SameDayOrderFeature,
  ButtonsOnDateAndTimePicker,
  OutOfServiceHoursFeature,
  ShowCancelOrderButtonFeature,
  EnableAfterCutOffBulkCemFeature,
  RestrictedVolumeLoadSizeFeature,
  RepeatActionBlkAdt,
  CancelActionBlkAdt,
  ModifyActionBlkAdt,
  CallActionsBlkAdt,
  NextBusinessDayPreSelectionFeature,
  TrucksDriversCertified,
  UnloadTypeAndApplicationCataloguesHomologationFeature,
  DisableEmailReceivingPersonPrefillFeature,
  CashOrderBlkAdt,
  OdmOrderCreationBlkAdt,
  CountOrderQuantityFromProductsFeature,
  HideRoleReceivingPersonFeature,
  DcoWaitingListRedesign2025,
  EmeaCalendarViewImprovementsFeature,
  NofJobsiteMultipleLocationsFeature,
  NofJobsiteFullAddressFeature,
  ChatBotAivoRealocatedFeature,
  ShowPodInsteadOfJobsiteFeature,
  EnabledVariousLocationV4,
} from './features/';
import { AppPropertyLoader } from './services/property-loader.service';
import { ReceivingPersonTestModifierFeature } from './features/receiving-person-test-modifier.feature';
import { SMSSubscriptionFeature } from './features/sms-subscription.feature';
import { SMSNotificationTestModifierFeature } from './features/sms-notification-test-modifier.feature';
import { EnableBusinessDays } from './features/enable-business-days.feature';
import { EnableOdmOrderCreation } from './features/enable-odm-order-creation.feature';
import { EnableContractDetail } from './features/enable-contract-detail.feature';
import { OrderSubscriptionMOOFeature } from './features/order-subscription-moo.feature';
import { RemoveContractFieldEnabled } from './features/RemoveContractFieldEnabled.feature';
import {
  AddReceivingPersonMoo,
  DeliveryInstructionsFieldMoo,
  OrderDetailLinkMOOFeature,
  RestrictedJobsiteMoo,
  CertifiedTrucksDriversMoo,
  EnableDefaultTimeAddMooFeature,
  EnableDefaultTimeDuplicateMooFeature,
  AutoSelectJobsiteMoo,
  SetNonWorkingDaysPickerMooFeature,
  MOOPrefillFeature,
} from './features/moo.feature';
import { TimeFormatByCountryUiFeature } from './features/time-format-by-country-ui.feature';
import { TimeFormatByLanguageUiFeature } from './features/time-format-by-language-ui.feature';
import { DateFormatByCountryUiFeature } from './features/date-format-by-country-ui.feature';
import { DateFormatByLanguageUiFeature } from './features/date-format-by-language-ui.feature';
import { TimeFormatByDefaultUiFeature } from './features/time-format-by-default-ui.feature';
import { DateFormatByDefaultUiFeature } from './features/date-format-by-default-ui.feature';
import { DateFirstDayWeekByCountryUiFeature } from './features/date-first-day-week-by-country-ui.feature';
import { DateFirstDayWeekByDefaultUiFeature } from './features/date-first-day-week-by-default-ui.feature';
import { DateFirstDayWeekByLanguageUiFeature } from './features/date-first-day-week-by-language-ui.feature';
import { ShowSpecificationManeuverFeature } from './features/additional-services.feature';
import { PumpPrimerAndUnloadTypeFeature } from './features/pump-primer.feature';
import { EnableOutRangeTagFeature } from './features/enable-outrange-tag.feature';
import { CloudContactModule } from './features/cloud-contact-module-enabled.feature';
import { DeliveryBlockedFeature } from './features/delivery-blocked.feature';
import { ShowUnderRiskColorTag } from './features/hideUnderRiskColorTag.feature';
import { EnableUnitsInAdmixturesFeature } from './features/enable-multiple-units-in-admixtures.feature';
import { NewOrderAfterCutoffFeature } from './features/new-order-after-cutoff.feature';
import { OrderConfirmToDispatchFeature } from './features/order-confirm-to-dispatch.feature';
import { JobSiteRestrictedFeature } from './features/job-site-restricted.feature';
import { EnableJobsiteDropdownRepearOrder } from './features/enable-jobsite-dropdown-repeatOrder.feature';
import { PodFilterFeature } from './features/pod-filter.feature';
import { EnableSecondMapCreateJobsite } from './features/enable-second-map-create-obsite.feature';
import { ImprovementsModifyOrderRulesFeature } from './features/improvements-modify-order-rules.feature';
import { CreditLimitExceededMessageFeature } from './features/credit-limit-exceeded-message.feature';
import { ActionLogsV7MultiProductFeature } from './features/action-logV7-multi-product.feature';
import { DisableCommentsRMXFeature } from './features/enable-comments-rmx.feature';
import { ProjectProfilesFeature } from './features/project-profiles.feature';
import { RepeatArkikFeature } from './features/repeat-arkik.feature';
import { SameDayMOOFeature } from './features/moo.feature';
import { OrderRejectionCodeFeature } from './features/order-rejection-code.feature';
import { AdditionalInfoFeature } from './features/additional-info.feature';
import { NewOrderFlowFeature } from './features/new-order-flow.feature';
import { DCOTimeExpirationMOOFeature } from './features/dco-time-expiration-moo.feature';
import { CleanUpFeature } from './features/clean-up.feature';
import { EnablePODCreateOnModifyOrderFeature } from './features/pod-create-on-modify-order.feature';
import { OrderListIconActionsMenuFeature } from './features/order-list-icon-actions-menu.feature';
import { HideBackButtonFromLastStep } from './features/hide-back-button-from-last-step.feature';
import { EnablePODCreateOnRepeatOrderFeature } from './features/pod-create-on-repeat-order.feature';
import { CustomSpacingFeature } from './features/custom-spacing.feature';
import { PrefillMooImprovementsAllWeeksFeature } from './features/prefill-moo-improvements-all-weeks';
import { EnableCalculationAvailabilityDate } from './features/enable-calculation-availability-date.feature';
import { EnableCalculationAvailabilityDateForCancel } from './features/enable-calculation-availability-date-for-cancel.feature';
import { EnableCalculationAvailabilityDateForModify } from './features/enable-calculation-availability-date-for-modify.feature';
import { PrefillMooIgnoreExperienceCheckFeature } from './features/prefill-moo-ignore-experience-check.feature';
import { CancelErrorHandlingFeature } from './features/cancel_error_handling.feature';
import { FormErrorHandlingOnTouchedFeature } from '@ordersnproducts/features/features/form-error-handling-on-touched.feature';
import { ModifyArkikFeature } from './features/modify-arkik.feature';
import { EnableNewPodArkikFeature } from './features/pod-on-modify-order-arkik.feature';
import { DcoLogsStatisticsFeature } from '@ordersnproducts/features/features/dco-logs-statistics.feature';
import { CancelErrorHandlingTimeFeature } from './features/cancel_error_handling_time.feature';
import { HideUnloadTimeFeature } from './features/hide-unload-time.feature';
import { LogisticChargesFeature } from './features/logistic-charges.feature';

@NgModule({
  providers: [
    AppPropertyLoader,
    CancelOrderFeature,
    ShowReqAndOrderFeature,
    EnableDownloadExcelFeature,
    ModifyOrderFeature,
    RepeatOrderFeature,
    OnHoldOrderFeature,
    AdjustmentOrderFeature,
    RmxAdditionalInfoFeature,
    NeorisLogoFeature,
    TimeNegotiationFeature,
    HideIndicativePricesFeature,
    NewActionLogsFeature,
    ShowUploadDocumentDropdownsFeature,
    IsOnlineOrderFeature,
    PumpingServiceFeature,
    ChatBotWizelineFeature,
    ChatBotAivoFeature,
    ChatBotAivoRealocatedFeature,
    ReceiveMyProductsFromV3Feature,
    CreateReceivingPersonModalFeature,
    WalkMeFeature,
    ShowTermsCheckboxOnUploadDocument,
    ShowProductCatalogOrdersTabFeature,
    ShowProductCatalogSuggestedTabFeature,
    ShowProductCatalogProductCatTabFeature,
    ShowProductCatalogFavoriteTabFeature,
    ShowProductCatalogMyListTabFeature,
    ShowLoadDefaultReceivingPerson,
    IsSalesReadonlyFeature,
    CreatePodRequestFeature,
    ShowLoadDefaultCatalogValuesFeature,
    BoomPumpFeature,
    CatalogPCMFeature,
    OrderActionMenuFeature,
    RmsWayFeature,
    ExtendedLogFeature,
    AddNewProductOneClickFeature,
    CalendarViewFeature,
    LocationAndSpecificationFeature,
    EnableActionLogV7Feature,
    PurchaseOrderMaskValidationFeature,
    HideMultiplePurchaseOrderFeature,
    AutomaticValidationFeature,
    CoBrowseFeature,
    SimmaOnlineFeature,
    OrderSubscriptionFeature,
    DeliveryBlockedFeature,
    DcoLogsStatisticsFeature,
    DcoImprovementFeature,
    DcoWaitingListRedesign2025,
    EnableCounterofferMatchBulkCEMFeature,
    ReceivingPersonTestModifierFeature,
    SMSSubscriptionFeature,
    SMSNotificationTestModifierFeature,
    CalendarViewV2Feature,
    EnableOrderAvailabilityExpirationTimeFeature,
    EnableOrderModificationExpirationTimeFeature,
    EnablePODDropdownFeature,
    EnablePODCreateOnModifyOrderFeature,
    EnablePODCreateOnRepeatOrderFeature,
    ProductDescriptionHomologationFeature,
    EnableBusinessDays,
    EnableSpecialScenariosMooFeature,
    EnableOdmOrderCreation,
    EnableContractDetail,
    EnableBusinessDaysCutOffFeature,
    EnableContractsExpirationDateFeature,
    EnableSpacingValidationByQtyLoadSize,
    OrderSubscriptionMOOFeature,
    RemoveContractFieldEnabled,
    EnablePODMooDropdownFeature,
    EnablePODDeleteMooFeature,
    AddReceivingPersonMoo,
    OrderMissingFieldsAlert,
    DeliveryInstructionsFieldMoo,
    TimeFormatByDefaultUiFeature,
    TimeFormatByCountryUiFeature,
    TimeFormatByLanguageUiFeature,
    DateFormatByDefaultUiFeature,
    DateFormatByCountryUiFeature,
    DateFormatByLanguageUiFeature,
    DateFirstDayWeekByCountryUiFeature,
    DateFirstDayWeekByDefaultUiFeature,
    DateFirstDayWeekByLanguageUiFeature,
    DeliveryTimePickerFeature,
    DeliveryTimeWindowSelectFeature,
    PalletsDefaultUnitBagCemFeature,
    SameDayMOOFeature,
    DisableCommentsRMXFeature,
    PaymentTermsFeature,
    LoadSizeFeature,
    RepeatArkikFeature,
    SameDayOrderFeature,
    OrderDetailLinkMOOFeature,
    RestrictedJobsiteMoo,
    CertifiedTrucksDriversMoo,
    ShowSpecificationManeuverFeature,
    PumpPrimerAndUnloadTypeFeature,
    EnableAdmixturesProductTypeFeature,
    ShowOneDeliveryMethodForAdmixturesFeature,
    ButtonsOnDateAndTimePicker,
    EnableOutRangeTagFeature,
    OutOfServiceHoursFeature,
    CloudContactModule,
    ShowCancelOrderButtonFeature,
    ShowUnderRiskColorTag,
    EnableUnitsInAdmixturesFeature,
    RestrictedVolumeLoadSizeFeature,
    NewOrderAfterCutoffFeature,
    EnableAfterCutOffBulkCemFeature,
    NextBusinessDayPreSelectionFeature,
    OrderConfirmToDispatchFeature,
    JobSiteRestrictedFeature,
    TrucksDriversCertified,
    EnableJobsiteDropdownRepearOrder,
    PodFilterFeature,
    EnableDefaultTimeAddMooFeature,
    EnableDefaultTimeDuplicateMooFeature,
    AutoSelectJobsiteMoo,
    SetNonWorkingDaysPickerMooFeature,
    EnableSecondMapCreateJobsite,
    ImprovementsModifyOrderRulesFeature,
    CreditLimitExceededMessageFeature,
    RepeatActionBlkAdt,
    CancelActionBlkAdt,
    ModifyActionBlkAdt,
    CallActionsBlkAdt,
    LeadTimesApiBlkAdt,
    ActionLogsV7MultiProductFeature,
    UnloadTypeAndApplicationCataloguesHomologationFeature,
    DisableEmailReceivingPersonPrefillFeature,
    CashOrderBlkAdt,
    OdmOrderCreationBlkAdt,
    CountOrderQuantityFromProductsFeature,
    ProjectProfilesFeature,
    OrderRejectionCodeFeature,
    MOOPrefillFeature,
    AdditionalInfoFeature,
    NewOrderFlowFeature,
    NofJobsiteFullAddressFeature,
    NofJobsiteMultipleLocationsFeature,
    DCOTimeExpirationMOOFeature,
    CleanUpFeature,
    HideRoleReceivingPersonFeature,
    EmeaCalendarViewImprovementsFeature,
    HideRoleReceivingPersonFeature,
    CustomSpacingFeature,
    PrefillMooImprovementsAllWeeksFeature,
    OrderListIconActionsMenuFeature,
    HideBackButtonFromLastStep,
    PrefillMooImprovementsAllWeeksFeature,
    ShowPodInsteadOfJobsiteFeature,
    EnableCalculationAvailabilityDate,
    EnableCalculationAvailabilityDateForCancel,
    EnableCalculationAvailabilityDateForModify,
    EnabledVariousLocationV4,
    PrefillMooIgnoreExperienceCheckFeature,
    CancelErrorHandlingFeature,
    CancelErrorHandlingTimeFeature,
    FormErrorHandlingOnTouchedFeature,
    ModifyArkikFeature,
    EnableNewPodArkikFeature,
    HideUnloadTimeFeature,
    LogisticChargesFeature,
  ],
})
export class AppFeaturesModule {}
